<template>
  <div class="web-camera-container" :class="isCameraOpen || isPhotoTaken ? 'active' : ''">
    <div v-if="!isCameraOpen" class="camera-button">
      <el-button size="mini" @click="toggleCamera">
        <span>Open Camera</span>
      </el-button>
    </div>

    <div class="under-camera-button">
      <div v-show="isCameraOpen && isLoading" class="camera-loading">
        <ul class="loader-circle">
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>

      <div v-show="!isCameraOpen && !isLoading">
        <span class="text-white">To begin the test, take a photo!</span>
      </div>
    </div>

    <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash': isShotPhoto }">

      <div class="camera-shutter" :class="{ 'flash': isShotPhoto }"></div>

      <video v-show="!isPhotoTaken" class="square" ref="camera" :width="300" :height="300" autoplay></video>
      <canvas v-show="isPhotoTaken" class="square" id="photoTaken" ref="canvas" :width="300" :height="300"></canvas>
    </div>

    <div v-if="isCameraOpen && !isLoading && !isPhotoTaken" class="camera-shoot">
      <button type="button" class="button" @click="takePhoto">
        <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
      </button>
    </div>



    <!-- <div v-if="isPhotoTaken" class="camera-download">
      <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
        Download
      </a>
    </div> -->

    <div v-if="isCameraOpen && !isLoading" class="retake-button">
      <el-button :disabled="!isPhotoTaken" size="mini" @click="retakePhoto">
        <span>Retake</span>
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CameraPhotoTake',
  data() {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#'
    }
  },

  methods: {
    toggleCamera() {
      debugger;
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      debugger;
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true
      });
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch(error => {
          this.isLoading = false;
          alert("May the browser didn't support or there is some errors.");
        });
    },
    stopCameraStream() {
      debugger;
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    takePhoto() {
      debugger;
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');
      const image = this.$refs.camera;

      const imageSize = Math.min(image.videoWidth, image.videoHeight);
      const x = (image.videoWidth - imageSize) / 2;
      const y = (image.videoHeight - imageSize) / 2;

      context.drawImage(image, x, y, imageSize, imageSize, 0, 0, canvas.width, canvas.height);

      // save it to store
      const dataURL = this.$refs.canvas.toDataURL('image/jpeg');
      this.$store.commit('setPhoto', dataURL);

      this.stopCameraStream();
    },
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },
    retakePhoto() {
      debugger;
      this.isPhotoTaken = !this.isPhotoTaken;
      this.isCameraOpen = true;
      this.createCameraElement();
    }
  }
}
</script>
<style lang="less" scoped>
.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;

  &.active {
    min-height: 425px;
  }
  
  .camera-button {
    margin-bottom: 1rem;
  }

  .under-camera-button {
   &> * {
    min-height: 2rem !important;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-direction: column;
    flex-wrap: wrap;
   }
  }
  
  .camera-box {    
    .camera-shutter {
      opacity: 0;
      width: 300px;
      height: 300px;
      background-color: #fff;
      position: absolute;
      
      &.flash {
        opacity: 1;
      }
    }
  }
  
  .camera-shoot {
    margin: 1rem 0;
    
    button {
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      
      img {
        height: 35px;
        object-fit: cover;
      }
    }
  }
  
  .camera-loading {
    
    ul {
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 999999;
      margin: 0;
    }
    
    .loader-circle {
      display: flex !important;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex-wrap: wrap;      
      height: 14px;
      margin: 0 auto;
      width: 100%;
      padding: 0;
      
      li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        border-radius: 100%;
        
        &:nth-child(1) {
          margin: 0;
        }

        &:nth-child(2) {
          animation-delay: .2s;
        }
        
        &:nth-child(3) {
          animation-delay: .4s;
        }
      }
    }
  }

  @keyframes preload {
    0% {
      opacity: 1
    }
    50% {
      opacity: .4
    }
    100% {
      opacity: 1
    }
  }

  .square {
    object-fit: cover;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CameraPhotoTake.vue